module.exports = __webpack_public_path__ + "@/assets/img/randstad-logo.a74bb2b2.svg";